import { useState, useEffect } from 'react';
import { PlayerStatsAPI } from '../models/PlayerStatsAPI';
import { fetchPlayerBySteamIdAndSeason } from '../services/PlayerStatService';

const usePlayerStats = (steamId: string | undefined, season: number | null, scope?: 'liga' | 'kval') => {
    const [stats, setStats] = useState<PlayerStatsAPI | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            if (!steamId || !season) {
                setLoading(false);
                return;
            }
            try {
                const data = await fetchPlayerBySteamIdAndSeason(steamId, season, scope);
                if (data) {
                    setStats(data);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [steamId, season, scope]);

    return { stats, loading };
};

export default usePlayerStats;
